import { FC, ReactNode } from 'react';
import styles from './styles.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, AppState } from '../../../../../../redux/store';
import ModalFooter from '../ModalFooter';
import {
  removeEditTask,
  setEditTask,
  calcTasksReadyToUpdate,
} from '../../../../../../redux/carAllocationEditSlice';
import { format } from 'date-fns';
import { useGetContractDetailQuery } from '../../../../../../api/contractApi';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useGetWasteItemsQuery } from '../../../../../../api/otherApi';
import { formatTime } from '../../../../../../services/formatTime';

const Confirm: FC = () => {
  const editState = useSelector(
    (state: AppState) => state.carAllocationEdit.editState
  );
  const dispatch = useDispatch<AppDispatch>();

  const hasCarSection = !!editState?.selectedCarName;
  const hasDriverSection = !!editState?.selectedUserName;
  const onNext = () => {
    dispatch(calcTasksReadyToUpdate());
    dispatch(removeEditTask());
  };
  const onBack = () => {
    if (!editState) {
      return;
    }
    dispatch(
      setEditTask({
        ...editState,
        step: editState.step === 4 ? 3 : 2,
      })
    );
  };
  const { data: contract } = useGetContractDetailQuery(
    editState?.primary.contractId ?? skipToken
  );
  const { data: wasteItems } = useGetWasteItemsQuery();
  const formatDateStr = (s: string) => format(new Date(s), 'yyyy/M/d');
  const collectDayStr = contract?.collectionConstraintDateStart
    ? `${formatDateStr(contract.collectionConstraintDateStart)}`
    : '';
  const collectTimeStr = contract?.collectionConstraintTimeStart
    ? contract.collectionConstraintTimeEnd
      ? `${formatTime(contract.collectionConstraintTimeStart)}-${formatTime(
          contract.collectionConstraintTimeEnd
        )}`
      : `${formatTime(contract.collectionConstraintTimeStart)}~`
    : '';
  const selectedWasteItemId =
    editState?.primary.type === 'unallocated'
      ? editState.primary.wasteItemId
      : undefined;
  const selectedWasteItem =
    editState?.primary.type === 'unallocated'
      ? wasteItems?.find((wi) => wi.wasteItemId === selectedWasteItemId)
          ?.wasteItem
      : ``;

  return (
    <div className={styles.container}>
      <div className={styles.sections}>
        <Section title="案件">
          <div>{`契約No: ${contract?.contractId}`}</div>
          <div>{`回収日: ${collectDayStr} ${
            collectTimeStr && collectTimeStr + '指定'
          }`}</div>
          <div>{`排出事業者: ${contract?.supplierCompanyInfo?.companyName}`}</div>
          {contract?.contractorCompanyInfo?.companyName && (
            <div>{`委託先: ${contract?.contractorCompanyInfo.companyName}`}</div>
          )}
          {contract?.wastePointCompanyInfo?.companyName && (
            <div>{`排出事業場: ${contract.wastePointCompanyInfo.companyName}`}</div>
          )}
          <div>{`作業: ${editState?.primary.workCategory?.name}`}</div>
          {selectedWasteItem && <div>{`廃棄品目: ${selectedWasteItem}`}</div>}
        </Section>
        {hasCarSection && (
          <Section title="車両">{editState?.selectedCarName}</Section>
        )}
        {hasDriverSection && (
          <Section title="ドライバー">{editState?.selectedUserName}</Section>
        )}
        <Section title="付随する作業">
          <div>{`作業: ${editState?.secondary.workCategory?.name}`}</div>
          <div>{`作業開始時間: ${
            editState?.secondary.startDate &&
            format(new Date(editState?.secondary.startDate), 'yyyy/M/d H:mm~')
          }`}</div>
        </Section>
      </div>
      <ModalFooter
        onNext={onNext}
        onNextLabel="追加"
        onBack={onBack}
      ></ModalFooter>
    </div>
  );
};

const Section: FC<{ title: string; children: ReactNode }> = ({
  title,
  children,
}) => {
  return (
    <div className={styles.sectionContainer}>
      <div className={styles.sectionHead}>{title}</div>
      <div className={styles.sectionContent}>{children}</div>
    </div>
  );
};

export default Confirm;
